<template>
  <div id="examLogin" v-show="show">
    <exam-header ></exam-header>
    <el-row>
      <el-col :span="12"  :offset="6">
        <div class="exam-choose" >
         <h3 class="title" >请选择试卷</h3>
          <div class="container">
            <div v-for="(item,index) in typeList" :key="index" @click="toNext(item.manageCom,item.result)">
              <el-button type="primary" class="choose-btn">
                <div class="btn-img"> <img  :src="item.btnIcon"/></div>
                <!-- <div>{{item.manageCom}}</div> -->
                <!-- <div class="btn-text"> {{item.manageCom == ''?'新人基础试卷':item.manageCom =='NEW_RISK'?'新人险种试卷':'地方考试试卷'}}</div> -->
                <div class="btn-text"> {{manageComFix(item.manageCom) }}</div>
                <div style="clear:both"></div>
              </el-button>
            </div>
          </div>
        </div>
      </el-col>
    </el-row>

  </div>
</template>

<script>
import api from '@/modules/api.js'
import session from '@/components/cache'
import examHeader from '@/layout/ExamHeader.vue'
export default {
  name: 'examChooseTest',
  components: {examHeader},
  data () {
    return {
      typeList: [],
      userInfo: {
        userId: session.session_get('businessNo'),
        manageCom: session.session_get('manageCom')
      },
      req: {
        businessNo: '',
        paperType:''
      },
      btnIcon: require('../../assets/exam/chooseTest_write.png'),
      show: false
    }
  },
  methods: {
    manageComFix(manageCom){
      if(manageCom == ''){
        return '新人基础试卷'
      } else if(manageCom == 'NEW_RISK'){
        return '新人险种试卷'
      }else if(manageCom == 'INTERNET'){
        return '互联网宣传和销售资质考试试卷'
      }else{
        return '地方考试试卷'
      }
    },
    // 获取考试结果列表
    getExamList () {
      let that = this
      api.getExamList(this.userInfo, function (res) {
        if (res.result.isSuccess === true) {
          console.log(res)
          that.typeList = res.data
          for (var i = 0; i < that.typeList.length; i++) {
            // 按钮图标
            that.typeList[i].btnIcon = require('../../assets/exam/chooseTest_write.png')
            if (that.typeList[i].result === '1') {
              // 成功
              that.typeList[i].btnIcon = require('../../assets/exam/chooseTest_success.png')
            } else if (that.typeList[i].result === '0') {
              // 失败
              that.typeList[i].btnIcon = require('../../assets/exam/chooseTest_fail.png')
            }
          }
        } else {
          that.$message.error(res.result.error)
        }
        that.show = true
      })
    },
    toNext (manageCom, result) {
      this.req.businessNo = session.session_get('businessNo')
      let type = ''
      if (manageCom === '') {
        type = '0'
      }else if(manageCom === 'NEW_RISK'){
        type='NEW_RISK'
      }else if(manageCom === 'INTERNET'){
        type = 'INTERNET'
      }else {
        type = '1'
      }
      let that = this
      this.req.paperType = type
      if (result === '' || result === null || result === undefined) {
        // 考试介绍页面
        this.$router.push({name: 'ExamDetail', query: {type: type}})
      } else if (result === '0') {
        // 考试不及格
        api.checkNextTime(this.req, function (res) {
          if (res.data === 3) {
            // 未失效可以重考
            that.$router.push({name: 'ExamDetail', query: {type: type}})
          } else if (res.data === 4) {
            that.$router.push({name: 'ExamResult', query: {type: type}})
          } else {
            // 未验证过,返回
            that.$router.push({name: 'examLogin', query: {}})
          }
        })
      } else { // 考试及格
        this.$router.push({name: 'ExamResult', query: {type: type}})
      }
    }
  },
  mounted () {
    // this.$app.NaviInit.init('入司考试')
    this.getExamList()
  }
}
</script>
<style lang="scss" scoped>

.exam-choose{
  border: solid 1px #D4DEE9;
  padding: 20px 50px 50px 50px;
  border-radius: 3%;
  max-width: 400px;
  margin: 0 auto;
  margin-top: 100px;
}
.title{
    text-align: center;
    color: #194793;
    font-weight: 900;
    margin: 20px 0px 50px 0

}
.container{
    text-align: center;
}
.choose-btn{
  border-radius: 10em;
  background-color: #F2F8FF;
  color:#194793;
  margin-bottom: 30px;
  padding: 15px 30px;
  border-color: #194793;
}
.btn-img{
    height: 15px;
    margin-right: 5px;
    float: left;
}
.btn-img img{
   height:100%;
}
.btn-text{
  float: left;
}
</style>



// WEBPACK FOOTER //
// src/pages/exam/examChooseTest.vue